/* global getMilestonesUrl, minDate, maxDate */

import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import MilestoneSectionForm from './MilestoneSectionForm';

export default function MilestonesEdit({ vikEnabled = true, ...props }) {
    const [postRoute, setPostRoute] = useState('');
    const [redirectRoute, setRedirectRoute] = useState('');
    const [resource, setResource] = useState(null);
    const [milestones, setMilestones] = useState([]);
    const [canDeleteMilestones, setCanDeleteMilestones] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [sections, setSections] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if ((typeof sections === 'object' && sections !== null) || sections?.length) {
            if (props.setTotalMilestoneSections) {
                props.setTotalMilestoneSections(countItems(sections));
            }
            setLoading(false);
        }
    }, [sections]);

    const countItems = (x) => {
        if (Array.isArray(x)) {
            return x.length;
        }
        if (x && typeof x === 'object') {
            return Object.keys(x).length;
        }
        return 0;
    };

    const fetchData = () => {
        axios
            .get(props.getMilestonesUrl)
            .then((response) => {
                const { data } = response;
                setPostRoute(data.postRoute);
                setRedirectRoute(data.redirectRoute);
                setResource(data.resource);
                setMilestones(data.milestones);
                setCanDeleteMilestones(data.canDeleteMilestones);
                setCanEdit(data.canEdit);
                setSections(data.sections);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <Fragment>
            {loading ? (
                <div>{$t('Loading')}...</div>
            ) : Array.isArray(sections) ? (
                sections?.map((individualSection, index) => {
                    const section = Object.keys(individualSection).length ? Object.keys(individualSection)[0] : null;

                    const filtered = milestones.filter((item) => {
                        return item.type.includes(section);
                    });

                    return (
                        <Fragment key={index}>
                            {Object.entries(individualSection).map(([section, sectionTitle]) => {
                                return (
                                    <Fragment key={section}>
                                        {(vikEnabled || (!vikEnabled && section === 'cash')) && (
                                            <MilestoneSectionForm
                                                postRoute={postRoute}
                                                redirectRoute={redirectRoute}
                                                resource={resource}
                                                milestones={filtered}
                                                canDeleteMilestones={canDeleteMilestones}
                                                canEdit={canEdit}
                                                section={section}
                                                sectionTitle={sectionTitle}
                                                minDate={props.minDate}
                                                maxDate={props.maxDate}
                                                submitButtonText={props.submitButtonText ? props.submitButtonText : $t('Update')}
                                                showCancelButton={props.showCancelButton}
                                                milestonesConfirmed={props.milestonesConfirmed}
                                                setMilestonesConfirmed={props.setMilestonesConfirmed}
                                                parentSection={props.parentSection ? props.parentSection : 'expense'}
                                            ></MilestoneSectionForm>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </Fragment>
                    );
                })
            ) : (
                typeof sections === 'object' &&
                sections !== null &&
                Object.entries(sections).map(([section, sectionTitle]) => {
                    const filtered = milestones.filter((item) => {
                        return item.type.includes(section);
                    });

                    return (
                        <Fragment key={section}>
                            {(vikEnabled || (!vikEnabled && section === 'cash')) && (
                                <MilestoneSectionForm
                                    postRoute={postRoute}
                                    redirectRoute={redirectRoute}
                                    resource={resource}
                                    milestones={filtered}
                                    canDeleteMilestones={canDeleteMilestones}
                                    canEdit={canEdit}
                                    section={section}
                                    sectionTitle={sectionTitle}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    submitButtonText={props.submitButtonText ? props.submitButtonText : $t('Update')}
                                    showCancelButton={props.showCancelButton}
                                    milestonesConfirmed={props.milestonesConfirmed}
                                    setMilestonesConfirmed={props.setMilestonesConfirmed}
                                    parentSection={props.parentSection ? props.parentSection : 'expense'}
                                ></MilestoneSectionForm>
                            )}
                        </Fragment>
                    );
                })
            )}
        </Fragment>
    );
}

if (document.getElementById('milestonesEdit')) {
    var rootEl = document.getElementById('milestonesEdit');
    ReactDOM.render(
        <App>
            <MilestonesEdit getMilestonesUrl={getMilestonesUrl} minDate={minDate} maxDate={maxDate} />
        </App>,
        rootEl,
    );
}
